import type { ReactNode } from 'react';
import { useMe } from '../lib/me';
import { Link, useLocation } from '../lib/router';
import { Icon } from '../components/Icon';

export const ADMIN_PAGES = [
  { id: '', label: 'Overview', icon: 'overview', perm: null },
  { id: 'users', label: 'Users', icon: 'users', perm: 'admin.users.view' },
  { id: 'roles', label: 'Roles', icon: 'roles', perm: 'admin.roles.view' },
  { id: 'clearance', label: 'Clearance Controls', icon: 'clearance', perm: 'admin.clearance.view' },
  { id: 'discord', label: 'Discord', icon: 'discord', perm: 'admin.discord.view' },
  { id: 'datasources', label: 'Data Sources', icon: 'database', perm: 'admin.datasources.view' },
  { id: 'backups', label: 'Backup & Restore', icon: 'backup', perm: 'admin.backups.view' },
  { id: 'logs', label: 'System Log', icon: 'log', perm: 'admin.logs.view' },
  { id: 'revisions', label: 'Revisions', icon: 'revisions', perm: 'admin.revisions.view' },
  { id: 'settings', label: 'Settings', icon: 'settings', perm: 'admin.settings.manage' },
];

export function AdminLayout({ children }: { children: ReactNode }) {
  const { can, tx } = useMe();
  const { path } = useLocation();
  const current = path.split('/')[2] ?? '';
  return (
    <div className="admin">
      <div className="admin-head">
        <div className="eyebrow"><Icon name="shield" size={14} /> Command</div>
        <h1>Admin Panel</h1>
      </div>
      <nav className="admin-nav" aria-label="Admin">
        {ADMIN_PAGES.filter((p) => !p.perm || can(p.perm)).map((p) => (
          <Link key={p.id} to={`/admin${p.id ? `/${p.id}` : ''}`} className={current === p.id ? 'active' : ''}>
            <Icon name={p.icon} size={16} /> {tx(p.label)}
          </Link>
        ))}
      </nav>
      <div className="admin-body">{children}</div>
    </div>
  );
}
